// @ngInject
function OrderCollectionsApiService(ResourcesService) {

  var endpoint = 'ordercollections';

  return {
    listAllOrderCollections: ResourcesService.apiFactory.get(endpoint + '/briefs'),
    listAllCurrencies: ResourcesService.apiFactory.get(endpoint + '/currencies'),
    getOrderCollectionById: ResourcesService.apiFactory.get(endpoint),
    saveOrderCollection: ResourcesService.apiFactory.save(endpoint + '/save', 'OrderCollection'),
    updateOrderCollection: ResourcesService.apiFactory.save(endpoint + '/update', 'OrderCollection')
  };
}

angular
  .module('ordercollections.api', [])
  .factory('OrderCollectionsApiService', OrderCollectionsApiService);
